import React from 'react'
import { compose } from 'recompose'
import _ from 'lodash/fp'
import moment from 'moment'
import { useMutation } from 'react-apollo'

import colors from '@fe/ui/colors'

import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import withStyles from '@material-ui/core/styles/withStyles'
import { Typography, Switch, Grid } from '@material-ui/core'

import { removeBuddyLoader, SET_MANAGED, REMOVE_MANAGED } from './buddiesQueries'

const styles = theme => ({
  // TBD
  switchBase: {
    color: colors.paleGreen,
    '&$checked': {
      color: colors.lightGreen
    },
    '&$checked + $track': {
      backgroundColor: colors.lightGreen
    }
  }
})

export const GreenSwitch = withStyles({
  switchBase: {
    color: colors.paleGreen,
    '&$checked': {
      color: colors.lightGreen
    },
    '&$checked + $track': {
      backgroundColor: colors.lightGreen
    }
  },
  checked: {},
  track: {}
})(({ classes, ...props }) => {
  return (
    <Switch classes={classes} {...props} />
  )
})

function ManageBuddyDialog ({
  open, // boolean
  hide, // function
  buddy,
  classes,
  removeBuddy,
  refetchBuddies
}) {
  const [removeWarning, setRemoveWarning] = React.useState(false)

  React.useEffect(() => {
    setRemoveWarning(false)
  }, [open, buddy])

  const [setManaged, { loading: loadingSetManaged }] = useMutation(SET_MANAGED)
  const [removeManaged, { loading: loadingRemoveManaged }] = useMutation(REMOVE_MANAGED)

  const waitingForMutation = loadingSetManaged || loadingRemoveManaged

  const handleRemoveBuddy = React.useCallback(() => {
    if (removeWarning) {
      removeBuddy({ variables: { id: _.get('id', buddy) } })
        .then(() => {
          refetchBuddies().then(hide)
        })
    } else {
      setRemoveWarning(true)
    }
  }, [buddy, removeBuddy, removeWarning])

  const handleCancel = React.useCallback(() => {
    if (removeWarning) {
      setRemoveWarning(false)
    } else {
      hide()
    }
  })

  const handleSwitchChange = async (_event, value) => {
    if (value) {
      await setManaged({ variables: { id: _.get('id', buddy) } })
    } else {
      await removeManaged({ variables: { id: _.get('id', buddy) } })
    }
    refetchBuddies()
    hide()
  }

  return (
    <Dialog
      open={open}
      onBackdropClick={hide}
      onEscapeKeyDown={hide}
    >
      <DialogContent>
        <Typography style={{ fontSize: 28 }}>
          Manage your Buddy
        </Typography>
        <Typography>
          You have been Buddies with {_.get('name', buddy)} since {moment(_.get('createdAt', buddy) * 1000).format('DD-MM-YYYY')}. As Buddies, you can see each others games, play together in GLFR and easily add each other as markers on a scorecard.
        </Typography>

        <div style={{ marginTop: 40, marginBottom: 40 }}>
          <Typography style={{ fontSize: 28 }}>
            Allow {_.get('name', buddy)} to keep scores for me
          </Typography>

          <Grid container>
            <Grid item xs={10}>

              <Typography>
                You can allow your Buddy to keep scorecards on your behalf. If you do so, they can add you to games on their device and keep your score, without you using your phone. The games will be available on your user afterwards.
              </Typography>
            </Grid>
            <Grid style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }} xs={2}>
              <GreenSwitch checked={Boolean(_.get('isManagedBy', buddy))} onChange={handleSwitchChange} disabled={waitingForMutation} />
            </Grid>
          </Grid>
        </div>

        {removeWarning && (
          <Typography style={{ color: colors.error }}>
            Are you sure you want to remove {_.get('name', buddy)} from your buddies?
          </Typography>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={handleCancel}>Cancel</Button>
        <Button style={{ color: colors.error }} onClick={handleRemoveBuddy}>{removeWarning ? 'YES, I AM SURE' : 'REMOVE BUDDY'}</Button>
      </DialogActions>
    </Dialog>
  )
}

export default compose(
  withStyles(styles),
  removeBuddyLoader
)(ManageBuddyDialog)
